import React from 'react';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';

import { constants } from '../../../config';
import { LINK_TYPES } from '../../../models/BaseBanner';
import { goToPage, routeNaming } from '../../../routes';
import { ScreenStore } from '../../../stores/ScreenStore';
import * as modalGlobal from '../../../common/global/modal';
import styles from './MainBannerCarousel.css';
import { BaseButton } from '../../../common/base-button';
import { Analytics } from '../../../helpers/Analytics';

const IPropTypes = {
  banners: PropTypes.arrayOf(PropTypes.shape({
    buttonColor: PropTypes.string,
    buttonText: PropTypes.string,
    buttonTextColor: PropTypes.string,
    description: PropTypes.string,
    imageUrl: PropTypes.string,
    linkType: PropTypes.oneOf(Object.values(LINK_TYPES)),
    linkValue: PropTypes.number,
    subtitle: PropTypes.string,
    textColor: PropTypes.string,
    title: PropTypes.string,
    message: PropTypes.string,
  })).isRequired,
};

class MainBannerCarousel extends React.Component {
  static getImageDensitySuffix() {
    const { breakpoints } = constants;
    if (ScreenStore.screenWidth <= breakpoints.mobileThreshold) {
      if (constants.pixelDensity >= 2) {
        return '3x';
      }
    }
    if (constants.pixelDensity === 1) {
      return '1x';
    }
    return '2x';
  }

  static getImageSizeSuffix() {
    const { breakpoints } = constants;
    if (ScreenStore.screenWidth <= breakpoints.mobileThreshold) {
      return 'mobile';
    } else if (ScreenStore.screenWidth <= breakpoints.smallMaxWidth) {
      return 'sm';
    } else if (ScreenStore.screenWidth <= breakpoints.mediumMaxWidth) {
      return 'md';
    }
    return 'lg';
  }

  constructor(props) {
    super(props);
    this._handleBannerClick = this._handleBannerClick.bind(this);
  }

  // eslint-disable-next-line class-methods-use-this
  _handleBannerClick(banner) {
    if (banner.linkType === LINK_TYPES.TO_CATEGORY) {
      goToPage(routeNaming.PRODUCT_INDEX, { subMenuId: banner.linkValue });
    } else if (banner.linkType === LINK_TYPES.TO_PRODUCT) {
      goToPage(routeNaming.PRODUCT_DETAIL, { id: banner.linkValue });
    } else if (banner.linkType === LINK_TYPES.TO_MESSAGE) {
      modalGlobal.showModal(
        '', banner.message, true, null,
        null, false, null,
        'Cerrar', true, null,
      );
    } else if (banner.linkType === LINK_TYPES.TO_LINK) {
      if (banner.message.includes('carlosgutierrez.com.uy')) {
        window.location.href = banner.message;
      } else {
        window.open(banner.message, true);
      }
    } else if (banner.linkType === LINK_TYPES.TO_MESSAGE_VIDEO) {
      Analytics.sendClickTracking('high_clicks', 'video');
      let videoTag = '';
      if (banner.message.includes('youtube')) {
        videoTag = `<div>
          <iframe width="100%" height="350" src="${banner.message}" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
        </div>`;
      } else {
        videoTag = `<video style="width: 100%" width="400" autoplay controls>
        <source src="${banner.message}">
        Your browser does not support HTML video.
      </video>`;
      }
      modalGlobal.showModal(
        '', videoTag, true, null,
        null, false, null,
        'Cerrar', true, null,
      );
    }
  }

  render() {
    const isMobile = ScreenStore.screenWidth <= constants.breakpoints.extraSmallMaxWidth;
    const sizeSuffix = MainBannerCarousel.getImageSizeSuffix();
    const densitySuffix = MainBannerCarousel.getImageDensitySuffix();
    return (
      <Carousel
        className={styles.carrouselcustom}
        showArrows
        showThumbs={false}
        showStatus={false}
        autoPlay
        infiniteLoop
        interval={6000}
        showIndicators={false}
        useKeyboardArrows
      >
        {this.props.banners.map(banner => (
          <div
            key={banner.id}
            className={styles.content}
            onClick={isMobile ? () => this._handleBannerClick(banner) : () => {}}
            role="presentation"
            style={{
              backgroundImage: `url(${banner.imageUrl}-${sizeSuffix}-${densitySuffix}.jpg)`,
            }}
          >
            <div
              className={styles.internalContent}
              style={{ color: `${banner.textColor}` }}
            >
              <h2 className={styles.title}>{banner.title}</h2>
              <h3 className={styles.subtitle}>{banner.subtitle}</h3>
              <p className={styles.description}>{banner.description}</p>
              <BaseButton
                className={styles.button}
                style={{
                  color: `${banner.buttonTextColor}`,
                  backgroundColor: `${banner.buttonColor}`,
                }}
                onClick={() => this._handleBannerClick(banner)}
              >
                {banner.buttonText}
              </BaseButton>
            </div>
          </div>))}
      </Carousel>
    );
  }
}

MainBannerCarousel.propTypes = IPropTypes;

const WrappedMainBanner = observer(MainBannerCarousel);

export { WrappedMainBanner as MainBannerCarousel };



// WEBPACK FOOTER //
// ./src/pages/home/main-banner-carousel/MainBannerCarousel.jsx